import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {LoginPageComponent} from './login/login-page/login-page.component';
import {NotFoundComponent} from './shared/404/404.component';
import {LogoutComponent} from './logout/logout.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { CancelledComponent } from './app-vms/cancelled/cancelled.component';
// Add the AuthGuard service
import {PostLoginPageComponent} from './login/post-login-page/post-login-page.component';
import {LoginAuthGuard, PostLoginAuthGuard} from './core/services/auth-guard.service';
import {AuthGuard} from './core/services/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: ':id/person/edit/:person_id',
    pathMatch: 'full'
  },
  {
    path: 'login/:guestId',
    component: LoginPageComponent,
    // canActivate: [ LoginAuthGuard ]
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'post-login',
    component: PostLoginPageComponent,
    canActivate: [ PostLoginAuthGuard ]
  },
  // Note that this Module (RequestModule) is not loaded into app.module.ts imports
  {
    path: 'request',
    loadChildren: 'app/app-vms/request/request.module#RequestModule',
    canActivate: [AuthGuard]
  },
  {
    path: "onboarding",
    loadChildren: 'app/app-onboarding/onboarding.module#OnboardingModule',
    // canActivate: [AuthGuard]
  },
  {
    path: 'cancelled',
    component: CancelledComponent
  },
  {
    path: 'welcome',
    component: WelcomeComponent
  },
  // We cannot uncomment this unless we put login route path or its children before here. Without it, if we
  // uncomment below, we will never hit the login path and the router will consider it a PageNotFound/404
  {
    path: '**',
    component: NotFoundComponent
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes,
      {
        // debugging purposes only
        // enableTracing: true,
        preloadingStrategy: PreloadAllModules
      })
  ],
  exports: [RouterModule],

})
export class AppRoutingModule {
}
